import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import ValueProp from './components/ValueProp';
import Pillars from './components/Pillars';
import AISection from './components/AISection';
import TargetAudience from './components/TargetAudience';
import Differential from './components/Differential';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import SEO from './components/SEO';
import SchemaOrg from './components/SchemaOrg';
import SolucionesPage from './pages/SolucionesPage';
import NosotrosPage from './pages/NosotrosPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactoPage from './pages/ContactoPage';

const HomePage: React.FC = () => {
  return (
    <>
      <SEO
        title="LQP Global | Ordenamos la complejidad digital de tu negocio"
        description="Soluciones digitales premium para pymes: sistemas a medida, automatización, inteligencia artificial y e-commerce. Transformamos procesos desordenados en negocios escalables. +150 empresas confían en nosotros."
        keywords="software para pymes, desarrollo web empresas, automatización empresarial, inteligencia artificial pymes, sistemas de gestión, digitalización pymes argentina, e-commerce, desarrollo a medida"
        url="https://lqpglobal.com"
      />
      <SchemaOrg type="organization" />
      <SchemaOrg type="localBusiness" />
      <SchemaOrg type="service" />
      <Hero />
      <ValueProp />
      <AISection />
      <Pillars />
      <TargetAudience />
      <Differential />
    </>
  );
};

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppContent: React.FC = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#050505] overflow-x-hidden selection:bg-red-500/30">
      {/* Background Decor */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-500/10 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-red-500/10 blur-[120px] rounded-full" />
      </div>

      <Header currentPath={location.pathname} />
      <ScrollToTop />

      <main className="relative z-10">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/soluciones" element={<SolucionesPage />} />
          <Route path="/nosotros" element={<NosotrosPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
        </Routes>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
